import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../../../core/services/auth/auth-guard.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilAtendente, usuarioPerfilFinanceiro, usuarioPerfilGerente, usuarioPerfilRepresentante } from '../../../usuario/usuario-perfil';


/** Acessos permitidos aos KPIs de Produtividade */
export const PRODUTIVIDADE_KPIS_ACESSOS: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilRepresentante, usuarioPerfilGerente, usuarioPerfilAtendente];

@Injectable()
export class CanActivateProdutividade implements CanActivateChild {

    constructor(private authGuard: AuthGuard) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(PRODUTIVIDADE_KPIS_ACESSOS);
    }
}
